import { FC, PropsWithChildren, PrimeReactProvider} from 'external/react'
import createRoutes from './routes'
import useAuth from 'context/auth-context/hook'
import { withContext } from './context'


const HomeShoolerApp : FC<PropsWithChildren> = () => {
	const {role} = useAuth()
	const routes = createRoutes(role)
	return (
		<PrimeReactProvider>
			{routes}
		</PrimeReactProvider>
	)
}
const HomeSchoolerAppWithAuthentication = withContext(HomeShoolerApp, 'auth')

export {HomeSchoolerAppWithAuthentication as default}
